/**
 * @generated SignedSource<<8f613d64a9edfd18f21cce14f31c97d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EquipmentCategory = "AUDIO_VIDEO" | "BATTERY" | "CABLE" | "CAMERA" | "CAMERA_ACCESSORY" | "ETC" | "KIT" | "LENS" | "LIGHTING" | "MEDIA" | "NETWORK" | "POWER" | "PRINTER" | "SECURITY" | "WORKSTATION" | "WORKSTATION_ACCESSORY" | "%future added value";
export type EquipmentQuery$variables = Record<PropertyKey, never>;
export type EquipmentQuery$data = {
  readonly rentalItems: {
    readonly nodes: ReadonlyArray<{
      readonly assetTag: any;
      readonly category: EquipmentCategory;
      readonly dailyRate: any | null | undefined;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly image: any | null | undefined;
      readonly kitMembers: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly name: string;
      readonly specifications: ReadonlyArray<string>;
    } | null | undefined> | null | undefined;
  };
};
export type EquipmentQuery = {
  response: EquipmentQuery$data;
  variables: EquipmentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 8
      }
    ],
    "concreteType": "AssetConnection",
    "kind": "LinkedField",
    "name": "rentalItems",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assetTag",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "image",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "category",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "specifications",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dailyRate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Asset",
            "kind": "LinkedField",
            "name": "kitMembers",
            "plural": true,
            "selections": [
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "rentalItems(first:8)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EquipmentQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "EquipmentQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f8c6a5a2d3c8def2cf1cd4563ec397e4",
    "id": null,
    "metadata": {},
    "name": "EquipmentQuery",
    "operationKind": "query",
    "text": "query EquipmentQuery {\n  rentalItems(first: 8) {\n    nodes {\n      id\n      assetTag\n      name\n      description\n      image\n      category\n      specifications\n      dailyRate\n      kitMembers {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b0a7a1f7bb9d5e0d1536696001168e70";

export default node;
